import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from 'services/config';
import { Pagination } from '@/models';
import { buildQueryString, prepareHeaders } from '@/state/slices/index.ts';
import { LogItem, LogItemParams } from '@/models/logItem';

export const LogItemAPI = createApi({
  reducerPath: 'logItemAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: config.BASE_URL,
    prepareHeaders,
  }),
  tagTypes: ['LogItem'],
  endpoints: (builder) => ({
    getLogItems: builder.query<Pagination<LogItem>, LogItemParams | void>({
      query: (filters) => {
        const queryString = filters
          ? buildQueryString(filters as Record<string, unknown>)
          : '';
        return {
          url: `/log-items/${queryString}`,
          method: 'GET',
        };
      },
      providesTags: (result) =>
        result
          ? [
              { type: 'LogItem', id: 'LIST' },
              ...result.results.map((log) => ({
                type: 'LogItem' as const,
                id: log.uuid,
              })),
            ]
          : [{ type: 'LogItem', id: 'LIST' }],
    }),

    createLogItem: builder.mutation<void, Partial<LogItem>>({
      query: (body) => ({
        url: '/log-items/',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'LogItem', id: 'LIST' }],
    }),

    exportLogItems: builder.query<Blob, LogItemParams | void>({
      query: (filters) => {
        const queryString = filters
          ? buildQueryString(filters as Record<string, unknown>)
          : '';
        return {
          url: `/log-items/export/${queryString}`,
          method: 'GET',
          responseHandler: (response) => response.blob(),
          cache: 'no-cache',
        };
      },
    }),
  }),
});

export const {
  useGetLogItemsQuery,
  useLazyGetLogItemsQuery,
  useCreateLogItemMutation,
  useLazyExportLogItemsQuery,
} = LogItemAPI;
